export default __webpack_public_path__ + "static/alawwal_mobile-03ee88397d1b9a1a51f12506ad6c7574.mp4";